<div class="newsletter-form">
  <app-loading-modal [show]="loading" message="Subscribing..."></app-loading-modal>

  <form [formGroup]="newsletterForm" (ngSubmit)="onSubmit()" class="form-container">
    <div class="input-group">
      <div class="input-wrapper">
        <input
          type="email"
          id="newsletter-email"
          formControlName="email"
          class="email-input"
          placeholder=" "
          autocomplete="email"
        />
        <label for="newsletter-email" class="email-label">Enter your email address</label>
        <div *ngIf="shouldShowError('email')" class="field-error">
          {{ getErrorMessage('email') }}
        </div>
      </div>
      <button 
        type="submit" 
        class="btn btn-primary subscribe-button"
        [disabled]="loading || newsletterForm.invalid">
        Subscribe
      </button>
    </div>
  </form>
</div>
